module.exports = __webpack_public_path__ + "img/GAME_FLAG2.e9dd67e2.jpg";